import contentPathUrlMapper from '../../src/utils/contentURLMapper';
import ESI from '../../src/components/ESI';
import logControl from '../../src/utils/logger-utils/logControl';

function Content({ url, query }) {
  const contentPath = contentPathUrlMapper(url);

  return (
    <>
      <ESI src={contentPath} id={`content-renderer-${query.path}`} />
    </>
  );
}

export async function getServerSideProps(context) {
  const { resolvedUrl, query } = context;
  logControl(context);

  return { props: { url: resolvedUrl, query } };
}

export default Content;
